import React, { Component } from "react";
import { Row, Col, Card, CardBody, Button, CardTitle } from "reactstrap";
import "bootstrap/dist/js/bootstrap.bundle";
import { Link } from "react-router-dom";

// datatable related plugins
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";
import { withTranslation } from "react-i18next";

import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { getLedgers, updateLedgers } from "api";

// Table data

class LedgerApproveStatusUpdate extends Component {
  constructor(props) {
    console.log(props);
    super(props);
    this.state = {
      props: props?.location?.query,
      page: 1,
      sizePerPage: 10,
      totalSize: 10,
      approveStatus:
        props?.location?.query.isEdit != 1
          ? props?.location?.query.data.approveStatus
          : "",
      paymentType:
        props.location.query && props.location.query.isEdit != 1
          ? props.location.query.data.paymentType
          : "NA",
      discount:
        props.location.query && props.location.query.isEdit != 1
          ? props.location.query.data.discount
          : "",
      ledgerList:
        props?.location?.query.isEdit != 1
          ? props?.location?.query.data.ledgerDetails
          : [],
    };
  }

  async update() {
    const data = await updateLedgers({
      id: this.state.props.data.id,
      approveStatus: this.state.approveStatus,
      paymentType: this.state.paymentType,
      discount: this.state.discount,
    });
  }

  render() {
    this.columns = [
      {
        dataField: "id",
        text: "#",
        sort: true,
        hidden: true,
      },
      {
        dataField: "id",
        text: `${this.props.t("Jangad Id")}`,
        formatter: (cell, row) => {
          return row.mainJangad.name;
        },
      },
      this.state.props.data.party
        ? {
            dataField: "partyName",
            text: "Party Name",
            sort: true,
            formatter: (row, cell) => {
              return this.state.props.data?.party?.name;
            },
          }
        : {
            dataField: "factoryName",
            text: `${this.props.t("Factory Name")}`,
            sort: true,
            formatter: (row, cell) => {
              return this.state.props.data?.factory?.name;
            },
          },
      {
        dataField: "pieces",
        text: `${this.props.t("Pieces")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.mainJangad.jangads.reduce((prev, current) => {
            return prev.cycle > current.cycle ? prev : current;
          }).pieces;
        },
      },
      {
        dataField: "weight",
        text: `${this.props.t("Weight")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.mainJangad.jangads.reduce((prev, current) => {
            return prev.cycle > current.cycle ? prev : current;
          }).weight;
        },
      },
    ];

    const defaultSorted = [
      {
        dataField: "id",
        order: "asc",
      },
    ];

    const pageOptions = {
      paginationSize: 5,
      pageStartIndex: 1,
      firstPageText: "First",
      prePageText: "Back",
      nextPageText: "Next",
      lastPageText: "Last",
      nextPageTitle: "First page",
      prePageTitle: "Pre page",
      firstPageTitle: "Next page",
      lastPageTitle: "Last page",
      onPageChange: (page, limit) => {
        this.setState({ page: page }, () => this.getStockList());
      },
      sizePerPageOptionRenderer: ({ text, page, onSizePerPageChange }) => {
        return (
          <li key={text} role="presentation" className="dropdown-item">
            <a
              href="#"
              className="text-dark"
              tabIndex="-1"
              role="menuitem"
              data-page={page}
              onMouseDown={e => {
                onSizePerPageChange(page);
                this.setState({ page: 1, sizePerPage: page }, () =>
                  this.getStockList()
                );
              }}
            >
              {text}
            </a>
          </li>
        );
      },
      sizePerPageList: [10, 25, 50, 100],
      page: this.state.page,
      totalSize: this.state.totalSize, // replace later with size(customers),
      custom: true,
    };

    const { SearchBar } = Search;

    //meta title

    const { history } = this.props;

    document.title = "admin-report";

    return (
      <React.Fragment>
        <div className="page-content">
          <div className="container-fluid">
            <h3 className="text-black fw-bold text-uppercase">
              {this.props.t("Ledger")}
            </h3>
            <Row>
              <Col className="col-12 mt-3">
                <Card>
                  <CardBody>
                    <div className="d-xxl-flex d-block justify-content-between text-center text-xxl-start">
                      <div className="">
                        <h3 className="text-black fw-bold">
                          {this.props.t("Ledger Approve Status Update")}
                        </h3>
                      </div>
                    </div>
                    <div className="d-xxl-flex d-block text-center text-xxl-start justify-content-between">
                      {/* <div className="pt-3 pt-xxl-0">
                        <div className="search-box me-2 mb-2 d-inline-block">
                          <div className="position-relative">
                            <label
                              htmlFor="search"
                              className="pt-2 fs-5 pe-1 pe-lg-3"
                            >
                              {this.props.t("Search Ledger ID")}
                            </label>
                            <select
                              id="ledgerID"
                              className="officestock-select"
                            >
                              <option value="1">LEDGER0000321</option>
                              <option value="2">LEDGER0000322</option>
                              <option value="3">LEDGER0000323</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="pt-3 pt-xxl-0">
                        <div className="search-box me-2 mb-2 d-inline-block">
                          <div className="position-relative">
                            <label
                              htmlFor="search"
                              className="pt-2 fs-5 pe-1 pe-lg-3"
                            >
                              {this.props.t("Payment Status")}
                            </label>
                            <select
                              id="factoryId"
                              className="officestock-select"
                            >
                              <option value="paid">paid</option>
                              <option value="Pending">Pending</option>
                              <option value="Refund">Refund</option>
                              <option value="Partial Paid">
                                Partial Paid
                              </option>
                            </select>
                          </div>
                        </div>
                      </div> */}
                    </div>
                    <Row>
                      <Col xl="12">
                        <div className="table-responsive">
                          <BootstrapTable
                            remote={true}
                            onTableChange={() => false}
                            keyField={"id"}
                            responsive
                            bordered={false}
                            striped={false}
                            data={this.state.ledgerList}
                            columns={this.columns}
                            classes={"table align-middle table-nowrap"}
                          />
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
            <div className="row">
              <div className="col-xl-10 col-12">
                <div className="row">
                  <label
                    htmlFor="approveStatus"
                    className="col-md-3 col-form-label"
                  >
                    <h5 className="text-secondary fw-bold fs-4">
                      {this.props.t("Approve Status")}
                    </h5>
                  </label>
                  <div className="col-md-9">
                    <select
                      className="form-control form-select fs-5"
                      value={this.state.approveStatus}
                      onChange={e => {
                        this.setState({
                          approveStatus: e.target.value,
                        });
                      }}
                      disabled={this.state.props.isEdit == 3 ? true : false}
                      rows="5"
                      name="approveStatus"
                    >
                      <option value="" disabled>
                        Select
                      </option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                      <option value="Pending">Pending</option>
                    </select>
                  </div>
                </div>
                <div className="row">
                  <label
                    htmlFor="paymentType"
                    className="col-md-3 col-form-label"
                  >
                    <h5 className="text-secondary fw-bold fs-4">
                      {this.props.t("Payment Method")}
                    </h5>
                  </label>
                  <div className="col-md-9">
                    <select
                      className="form-control form-select fs-5"
                      value={this.state.paymentType}
                      onChange={e => {
                        this.setState({
                          paymentType: e.target.value,
                        });
                      }}
                      disabled={this.state.props.isEdit == 3 ? true : false}
                      rows="5"
                      name="paymentType"
                    >
                      <option value="NA" disabled>
                        Select
                      </option>
                      <option value="Cash">Cash</option>
                      <option value="Bank">Bank</option>
                    </select>
                  </div>
                </div>
                <div className="row">
                  <label htmlFor="discount" className="col-md-3 col-form-label">
                    <h5 className="text-secondary fw-bold fs-4">
                      {this.props.t("Discounted Price")}
                    </h5>
                  </label>
                  <div className="col-md-9">
                    <input
                      className="form-control fs-5"
                      value={this.state.discount}
                      onChange={e => {
                        this.setState({
                          discount: e.target.value >= 0 ? e.target.value : 0,
                        });
                      }}
                      disabled={this.state.props.isEdit == 3 ? true : false}
                      type="number"
                      min={0}
                      name="discount"
                    ></input>
                  </div>
                </div>
              </div>
              {this.state.props.isEdit == 3 ? (
                ""
              ) : (
                <div className="col-lg-12 text-end pt-3">
                  <Button
                    color="primary"
                    className="fs-4 w-xl"
                    type="submit"
                    onClick={() => this.update()}
                  >
                    Update Ledger
                  </Button>
                </div>
              )}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default withTranslation()(LedgerApproveStatusUpdate);
